import cx from 'classnames'

import { UserMissionCard } from '@components/UserMissionCard'
import { UserMissionSkeleton } from '@components/UserMissionSkeleton'
import { UserMissionEnum } from '@interfaces/UserMissionEnum'
import NoData from '@components/NoData'
import { UserMissionPageProps } from './interface'

const privacyOptions = [
  { value: UserMissionEnum.READER, label: 'นักอ่าน' },
  { value: UserMissionEnum.WRITER, label: 'นักเขียน' },
]

export function UserMissionPage({
  data,
  isLoading,
  userMissionType,
  handleUserMissionTypeChange,
}: UserMissionPageProps) {
  return (
    <>
      <div className='relative flex text-[14px] text-secondary-1'>
        {privacyOptions.map((menu, i) => (
          <button
            key={i}
            className={cx('flex py-[10px] px-[20px] font-light z-10', {
              'border-b-[3px] border-secondary dark:border-dark-10 font-bold text-secondary dark:text-dark-10':
                userMissionType === menu.value,
            })}
            onClick={() => handleUserMissionTypeChange(menu.value)}
          >
            {menu.label}
          </button>
        ))}
        <div className='absolute w-full h-[1px] bottom-0 bg-gray-3 dark:bg-purple z-0' />
      </div>

      {isLoading ? (
        <div className='grid grid-cols-3 tablet:grid-cols-2 my-[20px] mobile:grid-cols-1 gap-x-[20px] gap-y-[64px] tablet-mobile:gap-y-[20px]'>
          {[...Array(3)].map((_, i) => (
            <UserMissionSkeleton key={i} />
          ))}
        </div>
      ) : !data.length ? (
        <div className='w-full text-center my-5'>
          <NoData />
        </div>
      ) : (
        <div className='grid grid-cols-3 tablet:grid-cols-2 my-[20px] mobile:grid-cols-1 gap-x-[20px] gap-y-[64px] tablet-mobile:gap-y-[20px]'>
          {data.map(item => (
            <UserMissionCard key={item.id} data={item} />
          ))}
        </div>
      )}
    </>
  )
}
